import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, EMPTY_FIELD_VALUE, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

interface Response {
  date_from: string;
  date_to: string;
  paid_claims_count: number;
  submitted_claims_count: number;
}
const QUERY_KEY = 'CLAIMS_ACTIVITY_REPORT_CARD';

const useClaimsActivityReportCardQuery = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    // TODO: the type is missing
    () => api.get<Response>(API_URL.REPORTS_CLAIM_ACTIVITY_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );
  const [fromDate, toDate] = useMemo(() => {
    const response = data?.data;
    const from = response?.date_from
      ? dayjs(response.date_from, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : null;
    const to = response?.date_to
      ? dayjs(response.date_to, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : null;
    return [from, to];
  }, [data?.data]);
  const isEmpty = useMemo(() => {
    return !toDate && !fromDate;
  }, [fromDate, toDate]);
  const title = useMemo(() => {
    if (isEmpty) {
      return null;
    }
    if (fromDate || toDate) {
      return `${fromDate || EMPTY_FIELD_VALUE} — ${toDate || EMPTY_FIELD_VALUE}`;
    }
    return EMPTY_FIELD_VALUE;
  }, [fromDate, isEmpty, toDate]);
  const formattedData = useMemo(() => {
    const response = data?.data;

    const paidClaimsCount = response?.paid_claims_count;
    const submittedClaimsCount = response?.submitted_claims_count;
    return {
      paidCount: paidClaimsCount || paidClaimsCount === 0 ? `${paidClaimsCount || 0}` : null,
      submittedCount:
        submittedClaimsCount || submittedClaimsCount === 0 ? `${submittedClaimsCount || 0}` : null,
    };
  }, [data?.data]);
  return {
    isLoading,
    title,
    isEmpty,
    data: formattedData,
  };
};

export default useClaimsActivityReportCardQuery;
